/**
 * Timezone utilities for calendar date sans timezone approach
 * This matches the backend's calendar date logic
 */

/**
 * Get user's timezone
 */
export const getUserTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (error) {
    console.warn('Failed to detect timezone, falling back to America/Los_Angeles');
    return 'America/Los_Angeles';
  }
};

/**
 * Get current calendar date in user's timezone (YYYY-MM-DD format)
 * This replaces the old UTC-based getTodayDate
 */
export const getTodayCalendarDate = () => {
  const now = new Date();
  // Use local date (user's timezone) instead of UTC
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Check if a date string is today in user's calendar
 */
export const isToday = (dateString) => {
  if (!dateString) return false;
  const today = getTodayCalendarDate();
  return dateString.split('T')[0] === today;
};

/**
 * Get time until midnight in user's timezone
 * Returns { hours, minutes, seconds }
 */
export const getTimeUntilMidnight = () => {
  const now = new Date();
  const tomorrow = new Date(now);
  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setHours(0, 0, 0, 0); // Set to midnight

  const msUntilMidnight = tomorrow.getTime() - now.getTime();

  const hours = Math.floor(msUntilMidnight / (1000 * 60 * 60));
  const minutes = Math.floor((msUntilMidnight % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((msUntilMidnight % (1000 * 60)) / 1000);

  return { hours, minutes, seconds };
};

/**
 * Format time until midnight as a string
 */
export const formatTimeUntilMidnight = () => {
  const { hours, minutes, seconds } = getTimeUntilMidnight();
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};

/**
 * Check if two dates are the same calendar day (timezone agnostic)
 */
export const isSameCalendarDay = (date1, date2) => {
  if (!date1 || !date2) return false;
  return date1.split('T')[0] === date2.split('T')[0];
};
